(function () {
  if (window.__nwBuyboxBound) return;
  window.__nwBuyboxBound = true;

  function applySelectedPlan(planRoot) {
    if (!planRoot) return;
    const selected = planRoot.querySelector('[data-nw-plan-input]:checked');
    const productInfo = planRoot.closest('product-info');
    const button = productInfo ? productInfo.querySelector('[name="add"]') : null;
    if (!button) return;

    if (!selected) {
      button.removeAttribute('data-subscription-product-varaint-id');
      button.removeAttribute('data-selling-plan-id');
      return;
    }

    const variantId = selected.getAttribute('data-subscription-variant-id');
    const sellingPlanId = selected.getAttribute('data-selling-plan-id');

    if (variantId) {
      button.setAttribute('data-subscription-product-varaint-id', variantId);
    } else {
      button.removeAttribute('data-subscription-product-varaint-id');
    }

    if (sellingPlanId) {
      button.setAttribute('data-selling-plan-id', sellingPlanId);
    } else {
      button.removeAttribute('data-selling-plan-id');
    }
  }

  function variantFromColorInput(input) {
    if (!input) return null;

    const variant = {
      id: Number(input.value),
      available: input.dataset.variantAvailable !== 'false',
    };

    if (input.dataset.featuredMediaId) {
      variant.featured_media = { id: Number(input.dataset.featuredMediaId) };
    }

    if (input.dataset.variantSku) {
      variant.sku = input.dataset.variantSku;
    }

    return variant;
  }

  function updateBuyboxVariantScript(input) {
    const colorRoot = input.closest('[data-nw-buybox-color]');
    const script = colorRoot ? colorRoot.querySelector('[data-selected-variant]') : null;
    const variant = variantFromColorInput(input);
    if (!script || !variant) return;
    script.textContent = JSON.stringify(variant);
  }

  function syncBuyboxColorVariant(productInfo, variant) {
    if (!productInfo || !variant?.id) return;
    const colorRoot = productInfo.querySelector('[data-nw-buybox-color]');
    if (!colorRoot) return;

    colorRoot.querySelectorAll('[data-nw-variant-input]').forEach(function (input) {
      input.checked = String(input.value) === String(variant.id);
    });

    const script = colorRoot.querySelector('[data-selected-variant]');
    if (script) {
      script.textContent = JSON.stringify(variant);
    }
  }

  function getBuyboxColorCtaLabel(productInfo) {
    const heading = productInfo.querySelector('.nw-buybox-color .nw-buybox-step__heading');
    return heading?.textContent?.trim() || '';
  }

  function getDefaultCtaLabel(button) {
    return button.getAttribute('data-cta-label') || window.variantStrings?.addToCart || 'Add to cart';
  }

  function setSubmitLabel(button, label) {
    const span = button?.querySelector('span');
    if (span && label) span.textContent = label;
  }

  function syncBuyboxSubmit(productInfo, selectedColor) {
    const variantInput = productInfo.querySelector('.product-variant-id');
    const button = productInfo.querySelector('[name="add"]');
    if (!variantInput || !button) return;

    variantInput.disabled = false;
    variantInput.value = selectedColor.value;

    if (selectedColor.disabled || selectedColor.dataset.variantAvailable === 'false') {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      return;
    }

    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    setSubmitLabel(button, getDefaultCtaLabel(button));
  }

  function syncBuyboxState(scope) {
    const root = scope || document;
    const productInfos = root.matches && root.matches('product-info') ? [root] : root.querySelectorAll('product-info');

    productInfos.forEach(function (productInfo) {
      const colorRoot = productInfo.querySelector('[data-nw-buybox-color]');
      const planRoot = productInfo.querySelector('[data-nw-buybox-plan]');
      if (!colorRoot) return;

      const selectedColor = colorRoot.querySelector('[data-nw-variant-input]:checked');
      const variantInput = productInfo.querySelector('.product-variant-id');
      const button = productInfo.querySelector('[name="add"]');

      if (!selectedColor) {
        if (variantInput) {
          variantInput.value = '';
          variantInput.disabled = true;
        }
        if (button) {
          button.setAttribute('disabled', 'disabled');
          button.setAttribute('aria-disabled', 'true');
          button.removeAttribute('data-subscription-product-varaint-id');
          button.removeAttribute('data-selling-plan-id');
          setSubmitLabel(button, getBuyboxColorCtaLabel(productInfo));
        }
        return;
      }

      syncBuyboxSubmit(productInfo, selectedColor);

      if (planRoot) {
        applySelectedPlan(planRoot);
      }

      document.dispatchEvent(
        new CustomEvent('nw-buybox-state-updated', {
          detail: { productInfo: productInfo },
        })
      );
    });
  }

  function bindPlan(planRoot) {
    if (!planRoot || planRoot.dataset.nwBuyboxPlanInit === '1') return;
    planRoot.dataset.nwBuyboxPlanInit = '1';
    planRoot.addEventListener('change', function (event) {
      if (!event.target.closest('[data-nw-plan-input]')) return;
      applySelectedPlan(planRoot);
    });
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-nw-buybox-plan]').forEach(bindPlan);
    syncBuyboxState(root);
  }

  function syncDawnPicker(productInfo, optionValueIds) {
    const dawnPicker = productInfo.querySelector('variant-selects:not([data-nw-buybox-color])');
    if (!dawnPicker || !optionValueIds.length) return false;

    optionValueIds.forEach(function (id) {
      const optionInput = dawnPicker.querySelector('[data-option-value-id="' + id + '"]');
      if (optionInput && !optionInput.checked && !optionInput.disabled) {
        optionInput.click();
      }
    });
    return true;
  }

  document.addEventListener(
    'change',
    function (event) {
      const input = event.target;
      if (!input.matches || !input.matches('[data-nw-variant-input]')) return;

      const colorRoot = input.closest('[data-nw-buybox-color]');
      if (!colorRoot) return;

      const productInfo = colorRoot.closest('product-info');
      const ids = (input.getAttribute('data-option-value-ids') || '')
        .split(',')
        .map(function (id) {
          return id.trim();
        })
        .filter(Boolean);

      if (colorRoot.getAttribute('data-nw-sync-dawn') === 'true' && productInfo) {
        event.stopPropagation();
        syncDawnPicker(productInfo, ids);
        syncBuyboxState(productInfo);
        return;
      }

      if (!ids.length || typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

      updateBuyboxVariantScript(input);

      event.stopPropagation();
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event: event,
          target: input,
          selectedOptionValues: ids,
        },
      });

      if (productInfo) {
        window.requestAnimationFrame(function () {
          syncBuyboxState(productInfo);
        });
      }
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const sectionId = event?.data?.sectionId;
      const variant = event?.data?.variant;
      const productInfo = sectionId
        ? document.querySelector('product-info[data-section="' + sectionId + '"]')
        : null;

      if (productInfo && variant) {
        syncBuyboxColorVariant(productInfo, variant);
      }

      syncBuyboxState(productInfo || document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
